import { useState } from 'react';

import CloseIcon from '@mui/icons-material/Close';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Button, Dialog, IconButton, Typography } from '@mui/material';
import TextField from '@mui/material/TextField';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Dayjs } from 'dayjs';

import './styles.css';

interface DialogCopyScheduleProps {
  open: boolean;
  handleClose(): void;
  handleSubmit(value: Dayjs | null): void;
}

export const DialogCopySchedule = ({ open, handleClose, handleSubmit }: DialogCopyScheduleProps) => {
  const [value, setValue] = useState<Dayjs | null>(null);

  const onSubmit = () => {
    handleSubmit(value);
    handleClose();
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Dialog onClose={handleClose} open={open} maxWidth="lg">
        <div className="copy-schedule-header">
          <IconButton onClick={handleClose} aria-label="close">
            <CloseIcon />
          </IconButton>
          <Typography sx={{ fontSize: 14, height: '50%', marginBottom: 0, marginLeft: '10px' }} gutterBottom>
            COPY SCHEDULE
          </Typography>
        </div>
        <div className="copy-schedule-content">
          <DesktopDatePicker
            label="Select Date"
            value={value}
            inputFormat="DD/MM/YYYY"
            onChange={(newValue) => {
              setValue(newValue);
            }}
            renderInput={(params) => <TextField variant="outlined" {...params} fullWidth />}
          />
        </div>
        <div className="copy-schedule-content">
          <Button
            variant="contained"
            color="primary"
            startIcon={<ContentCopyIcon />}
            sx={{ width: '100%' }}
            onClick={onSubmit}>
            COPY
          </Button>
        </div>
      </Dialog>
    </LocalizationProvider>
  );
};
